export const colors = {
	blue: "#2572b5",
	teal: "#40B0C0",
	green: "#20A040",
	yellow: "#F09000",
	orange: "#F06000",
	red: "#E01010",
	purple: "#6030A0",
	gray: "#606060",
	brown: "#A05000",
	magenta: "#E02060",
	pink: "#C063B4",
	active: "#007AFF",
	text: "#000",
	muted: "#3e3e3e",
	page: "rgb(240, 240, 240)",
	card: "#fff",
	line: "#ddd"
};

export const themeColor = colors.blue;
